<template>
  <b-container>
    <b-row class="main-content" :class="{'mt-3':!this.fetching&&!this.error}" align-v="center" align-h="center">
      <b-row align-h="center" class="mx-2 w-100" >
        <b-row class="w-100" v-if="!this.error&&!this.fetching">
          <b-card-group class="w-100 smooth px-2" deck>

            <b-card v-if="this.userInfo.admin===1&&false" bg-variant="light">
              <b-card-title>搜索</b-card-title>
              <b-card-text>
                <b-form-input v-model="search" placeholder="交易历史，贷款，透支"></b-form-input>
                <b-form-group class="mt-3 text-center">
                  <b-form-radio-group id="radio-group-2" v-model="type" name="radio-sub-component">
                    <b-form-radio value="transaction">交易历史</b-form-radio>
                    <b-form-radio value="loan">贷款</b-form-radio>
                    <b-form-radio value="overdraft">透支</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-card-text>
              <b-button block :variant="(this.fuzzysearch)?'success':'secondary'" @click="fuzzysearch=!fuzzysearch">模糊搜索({{(this.fuzzysearch)?'已开启':'已关闭'}})</b-button>
              <b-button block variant="primary" @click="searchDB()">确定</b-button>
            </b-card>

            <b-card bg-variant="dark" text-variant="white">
              <b-card-title>总存款</b-card-title>
              <b-card-text>
                <h1 class="bignumber-scroll-view">{{totalBalance}}￥</h1>
                <b-button variant="outline-light" @click="createCard()">开卡</b-button>
              </b-card-text>
              <b-card-text class="small text-muted">Last update at {{this.lastUpdateDate}}</b-card-text>
            </b-card>

            <b-card bg-variant="light">
              <b-card-title>贷款</b-card-title>
              <b-card-text>
                <h1 class="bignumber-scroll-view">{{totalLoan}}￥</h1>
              </b-card-text>
              <b-card-text class="small text-muted">Last update at {{this.lastUpdateDate}}</b-card-text>
            </b-card>

            <b-card class="smooth" :bg-variant="this.credit" text-variant="white">
              <b-card-title>信用</b-card-title>
              <b-card-text>
                <h1>{{(this.userInfo.credit/10)*100}}%</h1>
              </b-card-text>
              <b-card-text class="small text-white">Last update at {{this.lastUpdateDate}}</b-card-text>
            </b-card>

          </b-card-group>
        </b-row>

        <Spinner
        :offline="this.error"
        :loading="this.fetching"
        @retry-action="getStatus()"
        />
        <div class="w-100"></div>
      </b-row>
    </b-row>
    <b-modal
      v-model="modalShow"
      ref="modal"
      title="开卡"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <b-row class="mx-3">
        <b-form-group label="可选卡类">
          <b-form-radio-group
            v-model="selected_variant"
            :options="card_variants"
            name="radios-stacked"
            stacked
          ></b-form-radio-group>
        </b-form-group>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Spinner from "../components/LoadingSpinner"
import {auth} from '../components/auth'
import {urls} from '../components/urls'

export default {
  name: 'Home',
  components:{
    Spinner
  },
  mixins: [auth,urls],
  data:function(){
    return {
      cards:[],
      error:false,
      fetching:true,
      lastUpdateDate:"",
      search:"",
      type:"",
      fuzzysearch:false,
      modalShow:false,
      card_variants:[          
        { text: 'Toggle this custom radio', value: 'first' },
        { text: 'Or toggle this other custom radio', value: 'second' },
        { text: 'This one is Disabled', value: 'third', disabled: true },
        { text: 'This is the 4th radio', value: { fourth: 4 } }
      ],
      selected_variant:""
    }
  },
  methods:{
    showToast:function(obj){
      this.$bvToast.toast(`${obj.content}`, {
        title: `${obj.title}`,
        toaster: obj.toaster,
        variant: obj.variant,
        solid: true,
        appendToast: true
      })
    },
    commafy:function(num){
        let str = num.toString().split('.');
        if (str[0].length >= 5) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }
        return str.join('.');
    },
    timeStamp2String:function(time){
      const datetime = new Date();
      datetime.setTime(time);
      const hour = (datetime.getHours()).toString();
      let minute = (datetime.getMinutes()).toString();
      if(minute.length===1)minute="0"+minute;
      return hour+":"+minute;
    },
    getStatus:function(){
      this.$axios.get(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/card",{headers: { "Authorization" : this.header}})
      .then(res=>{
        this.error=false;
        this.fetching=false;
        console.log(res.data);
        this.cards=res.data;
        this.lastUpdateDate=this.timeStamp2String(Date.now());
      })
      .catch(error => {
        this.error=true;
        this.fetching=false;
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      }); 
      return 0
    },
    getCvs:function(){
      this.$axios.get(this.fetchUrl+"/api/card",{headers: { "Authorization" : this.header}})
        .then(res=>{
          this.card_variants=res.data.map(cv=>{
            return {
              text:`${cv.bank}的${cv.codename},${(cv.overdraft_max===0)?'不可透支':`可透支${cv.overdraft_max}￥`},可贷款${cv.loan_max}￥`,
              value:cv.cv_id
            }
          });
          return 0
        })
        .catch(error => {
          if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
          } else if (error.request) {
              console.log(error.request);
          } else {
              console.log('Error', error.message);
          }
          console.log(error.config);
        });
    },
    searchDB:function(){
      if(this.search.trim()===""){
        this.$bvToast.toast("无法搜索，请检查你的输入", {
          title: `错误`,
          toaster: 'b-toaster-bottom-center',
          variant: 'danger',
          solid: true,
          appendToast: true
        })
        return 1;
      }
      let url="";
      switch(this.type){
        case "transaction":
          url="transaction"
          break
        case "loan":
          url="loan"
          break
        case "overdraft":
          url="overdraft"
          break
        default:
          this.$bvToast.toast("未知类型，请检查你的选择", {
            title: `错误`,
            toaster: 'b-toaster-bottom-center',
            variant: 'danger',
            solid: true,
            appendToast: true
          })
          return 1
      }
      this.$axios.get(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/"+url,{headers: { "Authorization" : this.header}})
      .then(res=>{
        this.error=false;
        this.fetching=false;
        console.log(res.data);
      })
      .catch(error => {
        this.error=true;
        this.fetching=false;
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      }); 
      return 0
    },
    resetModal:function() {
      this.selected_variant="";
      return 0
    },
    handleCancel:function(){
      this.resetModal();
      this.showToast({content:'操作取消',variant:'warning',toaster:'b-toaster-bottom-center',title:'警告'})
      return 0
    },
    handleOk:function(bvModalEvt){
      if(this.selected_variant===""){
        bvModalEvt.preventDefault()
        this.showToast({content:'操作失败,请检查你选择的卡类型',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'})
        return 1
      }
      this.modalShow1=false;
      this.$axios.post(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/card/",
        {
          cv_id:this.selected_variant,
          phone:this.userInfo.phone,
          password:this.userInfo.password
        }
        ,{headers: { "Authorization" : this.header}})
        .then(res=>{
          this.showToast({content:'操作成功',variant:'success',toaster:'b-toaster-bottom-center',title:'提示'});
          this.getStatus();
          this.resetModal();
          this.fetching=false;
          return 0
        })
        .catch(error => {
          this.showToast({content:'操作失败',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'});
          this.resetModal();
          this.fetching=false;
          if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
          } else if (error.request) {
              console.log(error.request);
          } else {
              console.log('Error', error.message);
          }
          console.log(error.config);
        });
      return 0
    },
    createCard:function(){
      this.modalShow=true;
    }
  },
  computed:{
    time(){
      let date=new Date(),
      week=["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]
      return date.getFullYear()+'-'+date.getMonth()+'-'+date.getDate()+'  '+week[date.getDay()];
    },
    totalBalance(){
      let total=0;
      this.cards.map(card=>{
        total+=card.balance;
        return card
      })
      return this.commafy(total.toFixed(3))
    },
    totalLoan(){
      let total=0;
      this.cards.map(card=>{
        if(card.amount!==null)total+=card.amount;
        return card
      })
      return this.commafy(total.toFixed(3))
    },
    credit(){
      if(this.userInfo.credit<=4&&this.userInfo.credit>0)return "warning";
      if(this.userInfo.credit===0)return "danger";
      return "success"
    }
  },
  mounted(){
    this.getStatus();
    this.getCvs();
  }
}
</script>

<style>
  #credit_section{
    transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
  }

  .bignumber-scroll-view{
    white-space: nowrap;  
    overflow:auto;
  }
</style>
